import { countWhere } from 'lib/array/arrayUtils'

const countType = (passengers: Array<App.Passenger>, type: string) => passengers.filter(p => p.type === type).length

export function countOccupantsFromPassengers(passengers: Array<App.Passenger>): App.Occupants {
  return {
    adults: countType(passengers, 'adult'),
    children: countType(passengers, 'child'),
    infants: countType(passengers, 'infant'),
  }
}

export function countOccupantsFromFlightPassenger(passengers: Array<App.Checkout.FlightPassenger>): App.Occupants {
  const adults = countWhere(passengers, (p) => p.type === 'adult')
  const children = countWhere(passengers, (p) => p.type === 'child')
  const infants = countWhere(passengers, (p) => p.type === 'infant')

  return {
    adults,
    children: children > 0 ? children : undefined,
    infants: infants > 0 ? infants : undefined,
  }
}
